import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'
import useLanguage from '../hooks/useLanguage'
import Cruise from '../types/Cruise'
import { getDateFormat } from '../utils/dates'

import Image from './Image'

type Props = {
  shipName?: string

  cruise: Cruise

  isRoadShow: boolean
}

const NextCruiseItem: React.FC<Props> = ({ shipName, cruise, isRoadShow }: Props) => {
  const language = useLanguage()
  const { t } = useTranslation()

  return (
    <div className='modal--nextCruise--item'>
      <Image
        src={`${cruise.cruise_images[language]}`}
        alt='cruise_image'
        className='modal--nextCruise--image'
      />
      <div className='modal--nextCruise--content'>
        <p className='modal--cruise--content--all modal--nextCruise--content--title text text--lineHeight24 text--margin-v8'>
          {cruise.cruise_name[language]}
        </p>
        {shipName && (
          <p className='modal--cruise--content--all text text--gray text--size14 text--margin-v8'>
            {shipName}
          </p>
        )}
        <p className='modal--cruise--content--all text text--gray text--size14 text--margin-v8'>
          {getDateFormat(cruise.cruise_start, cruise.cruise_end, language)}
        </p>
        {!isRoadShow && (
          <a
            className='modal--cruise--cta modal--cruise--button text text--size14 text--white button--dark button--linkoutside'
            href={cruise.cruise_url}
            target='_blank'
            rel='noreferrer'
          >
            {t('modal.more')}
          </a>
        )}
      </div>
    </div>
  )
}

export default memo(NextCruiseItem)
